{
  "modal": {
    "loading": "Loading…",
    "share": "Copy task link",
    "description": "Description",
    "description_placeholder": "Add a description…",
    "link": "Link",
    "link_placeholder": "https://… (video, document, etc.)",
    "attachments": "Attachments",
    "subtasks": "Subtasks",
    "subtask_add": "Add",
    "subtask_add_full": "Add subtask",
    "subtask_placeholder": "Subtask name (Esc to cancel)",
    "subtask_open_title": "Open subtask",
    "subtask_assign": "Set assignee",
    "delete_title": "Delete",
    "activity": "Activity ({n})",
    "activity_empty": "No comments yet. Be the first to write one.",
    "loading_older": "Loading older messages…",
    "conversation_start": "Start of conversation",
    "comment_delete": "Delete",
    "comment_placeholder": "Write a comment… (type {'@'} to mention)",
    "attach_file": "Attach file",
    "send": "Send",
    "properties": "Properties",
    "projects": "Projects",
    "project_principal": "main",
    "project_add_title": "Add to another project",
    "project_remove_title": "Remove from this project",
    "assignee": "Assignee",
    "collaborators": "Collaborators",
    "unassigned": "Unassigned",
    "assign_me": "Assign to me",
    "assign_to": "Set assignee",
    "add_collaborator": "Add collaborator",
    "remove_collaborator": "Remove collaborator",
    "search_member": "Search member…",
    "no_members": "No results",
    "tracking": "Tracking",
    "start_task": "Start task",
    "pause_task": "Pause",
    "resume_task": "Resume",
    "complete_task": "Complete",
    "running": "Running",
    "paused": "Paused",
    "created_at": "Created",
    "started_at": "Started",
    "completed_at": "Completed",
    "duration": "Active time",
    "due_date": "Due date",
    "priority": "Priority",
    "recurrence": "Repeat",
    "recurrence_none": "Doesn't repeat",
    "recurrence_daily": "Every day",
    "recurrence_weekly": "Every week",
    "recurrence_monthly": "Every month",
    "recurrence_yearly": "Every year",
    "recurrence_custom": "Custom…",
    "recurrence_every": "Every",
    "recurrence_until": "Until",
    "recurrence_warning_no_date": "Add a due date to set when it repeats.",
    "uploading": "Uploading…",
    "delete_task": "Delete task",
    "channel_connect_failed": "Could not connect to the task channel:",
    "size": "Size",
    "size_none": "Not set",
    "deps_blocked_by": "Blocked by",
    "deps_blocks": "Blocks",
    "deps_add": "Add",
    "deps_add_full": "Add dependency",
    "deps_search": "Search task…",
    "deps_empty": "No results",
    "deps_remove": "Remove dependency",
    "deps_blocked_badge": "Blocked by {n} task | Blocked by {n} tasks",
    "overdue": "Overdue",
    "requester": "Requester",
    "requester_none": "No requester",
    "requester_name_placeholder": "Who asked for this",
    "requester_email_placeholder": "Email (optional)",
    "requester_edit_title": "Edit requester",
    "requester_save": "Save",
    "requester_cancel": "Cancel",
    "requester_external": "Ticket from the public portal"
  },
  "freq": {
    "day_one": "day",
    "day_other": "days",
    "week_one": "week",
    "week_other": "weeks",
    "month_one": "month",
    "month_other": "months",
    "year_one": "year",
    "year_other": "years"
  },
  "recurrence_label": {
    "every_one": "Every {word}",
    "every_n": "Every {n} {word}",
    "until_suffix": " until {date}"
  },
  "time": {
    "today": "Today {time}",
    "yesterday": "Yesterday {time}",
    "date_time": "{date} {time}"
  },
  "priority": {
    "low": "Low",
    "medium": "Medium",
    "high": "High",
    "urgent": "Urgent"
  },
  "confirm": {
    "delete_subtask_title": "Delete this subtask?",
    "delete_subtask_message": "It will be removed along with its comments and attachments.",
    "delete_attachment_title": "Delete this attachment?",
    "delete_attachment_message": "The file will be permanently deleted.",
    "delete_comment_title": "Delete this comment?",
    "delete_comment_message": "It will be removed along with its attachments.",
    "delete_task_title": "Delete this task?",
    "delete_task_message": "Its comments, attachments, and subtasks will be lost.",
    "delete_task_action": "Delete task"
  },
  "board": {
    "rename": "Rename",
    "reset_name": "Reset name",
    "rename_task_title": "Edit name",
    "delete": "Delete",
    "min_one_column_title": "At least one column must remain",
    "delete_column_title": "Delete column",
    "mark_pending": "Mark as pending",
    "mark_done": "Mark as completed",
    "attachments_title": "Attachments",
    "comments_title": "Comments",
    "task_placeholder": "Task name",
    "add_task": "Add task",
    "add": "Add",
    "cancel": "Cancel",
    "create": "Create",
    "add_column": "Add column",
    "column_placeholder": "Column name",
    "completed_count": "No completed | {n} completed | {n} completed",
    "load_more": "Load more",
    "loading": "Loading…",
    "drag_column_title": "Drag to reorder column",
    "age_title": "Time since it was created",
    "completed_in_title": "Time it took to complete",
    "completed_in": "Completed in {duration}",
    "duration_under_minute": "under 1 min",
    "status_title": "Current status on the board",
    "size_title": "Estimated size",
    "column_menu_title": "Column options",
    "view_list": "List",
    "view_board": "Board",
    "view_calendar": "Calendar",
    "view_timeline": "Timeline",
    "subtasks_title": "Subtasks",
    "subtasks_show": "Show subtasks",
    "subtasks_hide": "Hide subtasks",
    "subtasks_progress_title": "{done} of {total} subtasks completed",
    "unassigned": "Unassigned",
    "unassigned_title": "This task has no assignee",
    "requested_by": "Requested by: {name}",
    "requested_by_title": "Requester"
  },
  "list": {
    "personal_no_project": "Personal · no project",
    "empty": "No tasks to show"
  },
  "calendar": {
    "weekdays": [
      "Mon",
      "Tue",
      "Wed",
      "Thu",
      "Fri",
      "Sat",
      "Sun"
    ],
    "month_prev": "Previous month",
    "month_next": "Next month",
    "today": "Today",
    "more_count": "+{n} more"
  },
  "timeline": {
    "zoom_day": "Day",
    "zoom_week": "Week",
    "zoom_month": "Month",
    "task_header": "Task",
    "unscheduled": "Unscheduled",
    "summary": "{n} scheduled tasks · {m} without date",
    "dow_labels": [
      "S",
      "M",
      "T",
      "W",
      "T",
      "F",
      "S"
    ],
    "empty": "No tasks with a date yet. Set a due date to see it here."
  },
  "time_tracker": {
    "title": "Time",
    "start": "Start",
    "start_title": "Start timer",
    "stop_title": "Stop · {time}",
    "manual": "Manual",
    "add_manual_title": "Add time manually",
    "notes_placeholder": "Notes (optional)",
    "cancel": "Cancel",
    "add": "Add",
    "running": "Running",
    "delete_title": "Delete",
    "empty": "No time tracked yet.",
    "confirm_delete_title": "Delete this time entry?",
    "confirm_delete_message": "{duration} will be removed from the history.",
    "confirm_delete_action": "Delete"
  },
  "attachment": {
    "compact_attach": "📎 Attach file",
    "drop_or_click": "Drag files here or click to select",
    "file_types": "Images, video, PDF, docs",
    "remove": "Remove"
  },
  "link": {
    "loading": "Opening the task…",
    "not_found": "This task no longer exists or you don't have access to it.",
    "error": "Couldn't open the task. Try again.",
    "go_to_my_tasks": "Go to my tasks"
  }
}
